import { createTheme, alpha, darken, lighten } from '@mui/material/styles';

const customComponents = {
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      contained: ({ theme }) => ({
        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light || lighten(theme.palette.primary.main, 0.3)})`,
        color: theme.palette.primary.contrastText,
        borderRadius: '8px',
        boxShadow: theme.shadows[2],
        textTransform: 'none',
        '&:hover': {
          background: `linear-gradient(135deg, ${darken(theme.palette.primary.main, 0.15)}, ${darken(theme.palette.primary.light || lighten(theme.palette.primary.main, 0.2), 0.1)})`,
          boxShadow: theme.shadows[4],
          // Reset the Material-UI default hover style
          '@media (hover: none)': {
            backgroundColor: 'transparent',
          },
        },
        '&.Mui-disabled': {
          background: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
          boxShadow: 'none',
        },
      }),
      outlined: ({ theme }) => ({
        borderRadius: '8px',
        textTransform: 'none',
        borderWidth: '2px',
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        '&:hover': {
          borderWidth: '2px',
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
      }),
    },
    defaultProps: {
      disableElevation: true,
    },
  },
};

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#4179E1' },
    secondary: { main: '#d7ccc8' },
    container: { main: '#0F172A' },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#bbbbbb',
    },
  },
  components: customComponents,
});

const lightTheme = createTheme({
  palette: {
    primary: { main: '#4179E1' }, // #4682B4 #4169E1  #4179E1
    secondary: { main: '#2E3B4E' },
    container: { main: '#0F172A' }, // #0F172A
    // background: { default: "#f1f8e9" },
    error: { main: '#c62828' },
  },
  components: customComponents,
});

// const lightTheme = createTheme({
//   palette: {
//     mode: "light",
//     primary: {
//       main: "#1976d2",
//     },
//     secondary: {
//       main: "#d81b60",
//     },
//     background: {
//       default: "#f0f0f0",
//       paper: "#ffffff",
//     },
//     text: {
//       primary: "#000000",
//       secondary: "#333333",
//     },
//   },
//   components: customComponents,
// });

export { darkTheme, lightTheme };
